<question [title]="title" [description]="description" [valueOnly]="valueOnly">
  <div class="panel">
    <ion-range *ngIf="!valueOnly" [(ngModel)]="value" color="dark" (ionChange)="valueChanged()" class="question-scale-range">
      <ion-label *ngIf="minLabel && !hasLongLabels" slot="start">{{minLabel}}</ion-label>
      <ion-label *ngIf="maxLabel && !hasLongLabels" slot="end">{{maxLabel}}</ion-label>
    </ion-range>
    <ion-grid *ngIf="!valueOnly && hasLongLabels">
      <ion-row>
        <ion-col size-sm="6">
          <ion-label class="ion-text-wrap long-label">{{minLabel}}</ion-label>
        </ion-col>
        <ion-col size-sm="6" class="ion-text-right">
          <ion-label class="ion-text-right ion-text-wrap long-label">{{maxLabel}}</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-button *ngIf="valueOnly && !hasLabels" expand="full" fill="clear" color="dark">{{(value).toFixed()}} / {{MAX_SCALE_STEPS}}</ion-button>
    <ion-range *ngIf="valueOnly && hasLabels" value="{{value}}" color="dark" class="question-scale-range value-only">
      <ion-label *ngIf="minLabel && !hasLongLabels" slot="start">{{minLabel}}</ion-label>
      <ion-label *ngIf="maxLabel && !hasLongLabels" slot="end">{{maxLabel}}</ion-label>
    </ion-range>
    <ion-grid *ngIf="valueOnly && hasLongLabels">
      <ion-row>
        <ion-col size-sm="6">
          <ion-label class="ion-text-wrap long-label">{{minLabel}}</ion-label>
        </ion-col>
        <ion-col size-sm="6" class="ion-text-right long-label">
          <ion-label class="ion-text-right ion-text-wrap">{{maxLabel}}</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</question>
